'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-8d6fcb04.js');

const rgPictureCss = ":host{display:block}img{max-width:100%;height:auto;-webkit-box-sizing:border-box;box-sizing:border-box;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}:host([expand]) img{width:100%;display:block}:host([ratio]){position:relative;padding-bottom:56.25%;height:0}:host([ratio]) img{position:absolute;top:50%;left:50%;width:100%;height:100%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}";

const RgPicture = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
        // 3. State() variables
        // ---------------------------------------
        // 4. Public Property API
        // ---------------------------------------
        this.srcsetXlarge = "";
        this.srcsetLarge = "";
        this.srcsetMedium = "";
        this.srcsetSmall = "";
        this.srcsetXsmall = "";
        this.srcsetXxsmall = "";
        this.expand = false;
    }
    // 5. Events section
    // ---------------------------------------
    // 6. Component lifecycle events
    // ---------------------------------------
    componentWillLoad() {
        // picture fill doesn't work when img is left in slot,
        // sho we're shifting the img to the shadow DOM
        var lightImage = this.element.querySelector("img");
        if (!!lightImage) {
            this.imageEl = lightImage;
            lightImage.hidden = true;
        }
        // check if ratio is set
        if (this.ratio) {
            // ratio should be written at "number:number"
            let ratioArr = this.ratio.split(":");
            if (ratioArr.length == 2) {
                let width = parseFloat(ratioArr[0]);
                let height = parseFloat(ratioArr[1]);
                this.ratioPercentage = (height / width) * 100;
            }
        }
    }
    // 7. Listeners
    // ---------------------------------------
    // 8. Public methods API
    // ---------------------------------------
    // 9. Local methods
    // ---------------------------------------
    // 10. render() function
    // ---------------------------------------
    render() {
        let style = this.ratioPercentage
            ? {
                paddingBottom: this.ratioPercentage + "%",
            }
            : null;
        return (index.h(index.Host, { style: style }, index.h("picture", { "srcset-xlarge": this.srcsetXlarge, "srcset-large": this.srcsetLarge, "srcset-medium": this.srcsetMedium, "srcset-small": this.srcsetSmall, "srcset-xsmall": this.srcsetXsmall, "srcset-xxsmall": this.srcsetXxsmall }, this.srcsetXlarge && (index.h("source", { srcSet: this.srcsetXlarge, media: "(min-width: 1600px)" })), this.srcsetLarge && (index.h("source", { srcSet: this.srcsetLarge, media: "(min-width: 1200px)" })), this.srcsetMedium && (index.h("source", { srcSet: this.srcsetMedium, media: "(min-width: 900px)" })), this.srcsetSmall && (index.h("source", { srcSet: this.srcsetSmall, media: "(min-width: 675px)" })), this.srcsetXsmall && (index.h("source", { srcSet: this.srcsetXsmall, media: "(min-width: 510px)" })), this.srcsetXxsmall && (index.h("source", { srcSet: this.srcsetXxsmall, media: "(min-width: 380px)" })), this.imageEl && (index.h("img", { src: this.imageEl.src, alt: this.imageEl.alt })), index.h("slot", null))));
    }
    get element() { return index.getElement(this); }
};
RgPicture.style = rgPictureCss;

exports.rg_picture = RgPicture;
